const maskTypeAlpha = { maskType: "alpha" } as const;
const maskTypeLuminance = { maskType: "luminance" } as const;

export function MobileWithLogos() {
  return (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_670_20)">
        <mask
          id="mask0_670_20"
          style={maskTypeAlpha}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="128"
          height="128"
        >
          <rect width="128" height="128" fill="url(#paint0_linear_670_20)" />
        </mask>
        <g mask="url(#mask0_670_20)">
          <rect
            x="19"
            y="20"
            width="90"
            height="103"
            rx="13"
            fill="#F6F7F9"
            stroke="#4D4D4D"
            strokeWidth="6"
          />
          <path
            d="M51.5 31H76.5"
            stroke="#4D4D4D"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <g clipPath="url(#clip1_670_20)">
            <mask
              id="mask1_670_20"
              style={maskTypeLuminance}
              maskUnits="userSpaceOnUse"
              x="29"
              y="79"
              width="32"
              height="32"
            >
              <path d="M61 79H29V111H61V79Z" fill="white" />
            </mask>
            <g mask="url(#mask1_670_20)">
              <path d="M61 79H29V111H61V79Z" fill="#07955F" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M61 85.0664C59.9765 86.0906 58.5621 86.7241 56.9999 86.7241C53.8766 86.7241 51.3446 84.1922 51.3446 81.069C51.3446 80.3387 51.4831 79.6408 51.7351 79H61V85.0664ZM61 96.5014C59.5131 96.0629 57.9393 95.8276 56.3104 95.8276C47.6335 95.8276 40.5162 102.504 39.8153 111H44.8054C45.4873 105.251 50.3781 100.793 56.3104 100.793C57.9795 100.793 59.5662 101.146 61 101.781V96.5014ZM29 101.495C33.4016 99.4223 36.4482 94.9462 36.4482 89.7586C36.4482 85.2785 34.1759 81.329 30.7209 79H29V101.495Z"
                fill="#10A46B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M39.8331 86.4684C40.0104 86.4137 40.1193 86.3805 40.1987 86.3637C40.2038 86.3626 40.2086 86.3617 40.213 86.3608C40.2122 86.3653 40.2113 86.37 40.2102 86.3752C40.1935 86.4548 40.1603 86.5641 40.1058 86.7419L38.618 91.591C38.5492 91.8152 38.5046 91.9597 38.4643 92.059C38.4611 92.0669 38.4581 92.0741 38.4552 92.0807C38.4513 92.0746 38.4471 92.068 38.4426 92.0606C38.3867 91.9695 38.3189 91.8344 38.2143 91.6245L37.3025 89.7956L38.9076 88.1858C39.0496 88.0434 39.0496 87.8124 38.9076 87.67C38.7656 87.5276 38.5353 87.5276 38.3933 87.67L36.7881 89.2798L34.9645 88.3653C34.7553 88.2604 34.6205 88.1925 34.5295 88.1363C34.5222 88.1318 34.5156 88.1276 34.5096 88.1237C34.5162 88.1209 34.5234 88.1178 34.5314 88.1146C34.6303 88.0742 34.7744 88.0294 34.998 87.9604L39.8331 86.4684ZM40.4776 85.662C40.3206 85.6042 40.1649 85.6254 40.049 85.6498C39.933 85.6743 39.7918 85.7179 39.6345 85.7664L34.7841 87.2632L34.7678 87.2682C34.5649 87.3308 34.3896 87.3849 34.2574 87.4388C34.1341 87.4891 33.9628 87.5704 33.8605 87.7345C33.7359 87.9345 33.7153 88.1827 33.8055 88.4007C33.8795 88.5794 34.0351 88.6878 34.1485 88.7577C34.2701 88.8327 34.434 88.9149 34.6239 89.0101L36.5238 89.9628C36.5584 89.9802 36.5755 89.9888 36.5877 89.9955L36.5884 89.9959L36.5889 89.9969C36.5956 90.009 36.6042 90.0261 36.6214 90.0607L37.5705 91.9644L37.5705 91.9645C37.6659 92.1556 37.7481 92.3206 37.8231 92.443C37.893 92.5567 38.0011 92.7127 38.1792 92.7869C38.3965 92.8772 38.6439 92.8567 38.8433 92.7317C39.007 92.6292 39.088 92.4575 39.1381 92.3337C39.1919 92.2011 39.2458 92.0254 39.3083 91.8219L40.8058 86.9407C40.8542 86.7831 40.8976 86.6416 40.922 86.5254C40.9463 86.4092 40.9675 86.253 40.9099 86.0954C40.8362 85.8942 40.678 85.7358 40.4776 85.662ZM41.9545 89.2455C41.8784 89.2455 41.8167 89.3074 41.8167 89.3837V95.2712C41.8167 95.3476 41.8784 95.4095 41.9545 95.4095H42.955C43.0311 95.4095 43.0927 95.3476 43.0927 95.2712V91.8364L44.4478 94.204C44.4724 94.247 44.5179 94.2734 44.5673 94.2734H45.2205C45.2699 94.2734 45.3154 94.247 45.34 94.204L46.7033 91.822V95.2712C46.7033 95.3476 46.765 95.4095 46.8411 95.4095H47.8415C47.9176 95.4095 47.9794 95.3476 47.9794 95.2712V89.3837C47.9794 89.3074 47.9176 89.2455 47.8415 89.2455H46.8411C46.7909 89.2455 46.7446 89.2729 46.7204 89.3171L44.898 92.6365L43.0758 89.3171C43.0515 89.2729 43.0052 89.2455 42.955 89.2455H41.9545ZM49.1566 89.2538C48.7333 89.2538 48.3986 89.5976 48.3986 90.0057C48.3986 90.4208 48.732 90.7658 49.1566 90.7658C49.5788 90.7658 49.9228 90.4232 49.9228 90.0057C49.9228 89.5953 49.5776 89.2538 49.1566 89.2538ZM54.7259 90.0057C54.7259 89.5976 55.0604 89.2538 55.4837 89.2538C55.9047 89.2538 56.25 89.5953 56.25 90.0057C56.25 90.4232 55.906 90.7658 55.4837 90.7658C55.0592 90.7658 54.7259 90.4208 54.7259 90.0057ZM52.7654 91.0284C52.3085 91.0284 51.877 91.1787 51.5389 91.4631V91.2246C51.5389 91.1483 51.4772 91.0864 51.4011 91.0864H50.4751C50.399 91.0864 50.3372 91.1483 50.3372 91.2246V95.2712C50.3372 95.3476 50.399 95.4095 50.4751 95.4095H51.4011C51.4772 95.4095 51.5389 95.3476 51.5389 95.2712V93.2396C51.5389 92.8644 51.6363 92.5914 51.7903 92.4141C51.9424 92.2391 52.1626 92.1422 52.4429 92.1422C52.6986 92.1422 52.8709 92.205 52.9842 92.3376C53.1024 92.4756 53.1816 92.7172 53.1816 93.1319V95.2712C53.1816 95.3476 53.2432 95.4095 53.3194 95.4095H54.2454C54.3215 95.4095 54.3832 95.3476 54.3832 95.2712V92.8914C54.3832 92.2611 54.2294 91.7907 53.9379 91.4776C53.6451 91.1628 53.2336 91.0284 52.7654 91.0284ZM48.5557 91.2246C48.5557 91.1483 48.6175 91.0864 48.6936 91.0864H49.6196C49.6958 91.0864 49.7574 91.1483 49.7574 91.2246V95.2712C49.7574 95.3476 49.6958 95.4095 49.6196 95.4095H48.6936C48.6175 95.4095 48.5557 95.3476 48.5557 95.2712V91.2246ZM55.0208 91.0864C54.9446 91.0864 54.883 91.1483 54.883 91.2246V95.2712C54.883 95.3476 54.9446 95.4095 55.0208 95.4095H55.9469C56.0229 95.4095 56.0846 95.3476 56.0846 95.2712V91.2246C56.0846 91.1483 56.0229 91.0864 55.9469 91.0864H55.0208ZM35.032 94.1976C35.032 94.1212 35.0937 94.0594 35.1698 94.0594H38.0031C38.9668 94.0594 39.6765 94.3386 40.1446 94.8259C40.6117 95.3121 40.8199 95.9864 40.8199 96.7405C40.8199 97.6254 40.5204 98.2949 39.986 98.7402C39.4556 99.1822 38.7118 99.3886 37.8488 99.3886H36.6416V102.048C36.6416 102.124 36.5799 102.186 36.5038 102.186H35.1698C35.0937 102.186 35.032 102.124 35.032 102.048V94.1976ZM36.6416 95.5299V97.907H37.7165C38.2404 97.907 38.6 97.7744 38.8274 97.5692C39.0529 97.3659 39.1662 97.075 39.1662 96.7185C39.1662 96.3344 39.0446 96.0434 38.8272 95.8467C38.6079 95.6484 38.2728 95.5299 37.8157 95.5299H36.6416ZM43.4505 96.4365C41.8886 96.4365 40.7219 97.6791 40.7219 99.372C40.7219 100.238 41.0113 100.965 41.5034 101.476C41.9955 101.987 42.6826 102.274 43.4615 102.274C44.1178 102.274 44.6543 102.063 45.0545 101.671V102.048C45.0545 102.124 45.1163 102.186 45.1924 102.186H46.372C46.448 102.186 46.5098 102.124 46.5098 102.048V96.6521C46.5098 96.5757 46.448 96.5139 46.372 96.5139H45.1373C45.0611 96.5139 44.9994 96.5757 44.9994 96.6521V96.9906C44.5939 96.6234 44.05 96.4365 43.4505 96.4365ZM42.2544 99.383C42.2544 98.8944 42.4145 98.507 42.6655 98.2429C42.9166 97.9786 43.2657 97.8296 43.66 97.8296C44.453 97.8296 45.0545 98.484 45.0545 99.383C45.0545 100.282 44.4191 100.87 43.66 100.87C43.2376 100.87 42.8889 100.715 42.6451 100.457C42.4009 100.198 42.2544 99.8276 42.2544 99.383ZM46.8888 96.5762C46.9143 96.5374 46.9575 96.5139 47.004 96.5139H48.3269C48.3829 96.5139 48.4332 96.5477 48.4544 96.5997L49.8111 99.9201L51.0755 96.6027C51.096 96.5492 51.1471 96.5139 51.2043 96.5139H52.4721C52.5176 96.5139 52.5602 96.5365 52.5859 96.5741C52.6115 96.6119 52.617 96.6599 52.6004 96.7024L49.6459 104.287C49.6253 104.34 49.5742 104.375 49.5175 104.375H48.2388C48.1931 104.375 48.1505 104.352 48.1249 104.315C48.0992 104.277 48.0937 104.229 48.1104 104.186L49.0597 101.752L46.8775 96.7071C46.859 96.6644 46.8633 96.6152 46.8888 96.5762Z"
                fill="white"
              />
            </g>
          </g>
          <g clipPath="url(#clip2_670_20)">
            <mask
              id="mask2_670_20"
              style={maskTypeLuminance}
              maskUnits="userSpaceOnUse"
              x="67"
              y="79"
              width="32"
              height="32"
            >
              <path d="M99 79H67V111H99V79Z" fill="white" />
            </mask>
            <g mask="url(#mask2_670_20)">
              <path d="M99 79H67V111H99V79Z" fill="#AB9FF2" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.9263 99.3951C79.6698 101.32 77.5644 103.757 74.7629 103.757C73.4385 103.757 72.165 103.212 72.165 100.843C72.165 94.8119 80.3999 85.4751 88.0406 85.4751C92.3872 85.4751 94.1191 88.4908 94.1191 91.9154C94.1191 96.3113 91.2666 101.337 88.4311 101.337C87.5312 101.337 87.0897 100.843 87.0897 100.06C87.0897 99.8551 87.1237 99.6337 87.1916 99.3951C86.2238 101.048 84.3561 102.581 82.6072 102.581C81.3338 102.581 80.6886 101.78 80.6886 100.656C80.6886 100.247 80.7735 99.8211 80.9263 99.3951ZM87.5081 91.7966C87.5081 92.7945 86.9193 93.2934 86.2607 93.2934C85.5921 93.2934 85.0133 92.7945 85.0133 91.7966C85.0133 90.7987 85.5921 90.2997 86.2607 90.2997C86.9193 90.2997 87.5081 90.7987 87.5081 91.7966ZM91.2503 91.7966C91.2503 92.7945 90.6615 93.2934 90.0029 93.2934C89.3343 93.2934 88.7555 92.7945 88.7555 91.7966C88.7555 90.7987 89.3343 90.2997 90.0029 90.2997C90.6615 90.2997 91.2503 90.7987 91.2503 91.7966Z"
                fill="#FFFDF8"
              />
            </g>
          </g>
          <g clipPath="url(#clip3_670_20)">
            <rect x="29" y="41" width="32" height="32" fill="#FFF9F2" />
            <mask
              id="mask3_670_20"
              style={maskTypeLuminance}
              maskUnits="userSpaceOnUse"
              x="29"
              y="41"
              width="32"
              height="32"
            >
              <path d="M61 41.0156H29.0312V72.9844H61V41.0156Z" fill="white" />
            </mask>
            <g mask="url(#mask3_670_20)">
              <path
                d="M54.8553 66.7778L50.0021 65.3326L46.3421 67.5205L43.7886 67.5194L40.1265 65.3326L35.2754 66.7778L33.7998 61.7963L35.2754 56.2677L33.7998 51.5933L35.2754 45.8L42.8556 50.3288H47.2751L54.8553 45.8L56.3309 51.5933L54.8553 56.2677L56.3309 61.7963L54.8553 66.7778Z"
                fill="#FF5C16"
              />
              <path
                d="M35.2764 45.8L42.8566 50.332L42.5551 53.4422L35.2764 45.8Z"
                fill="#FF5C16"
              />
              <path
                d="M40.1279 61.7986L43.4632 64.3392L40.1279 65.3328V61.7986Z"
                fill="#FF5C16"
              />
              <path
                d="M43.1956 57.5983L42.5546 53.4446L38.4514 56.2689L38.4492 56.2679V56.27L38.4619 59.1773L40.1258 57.5983H40.1269H43.1956Z"
                fill="#FF5C16"
              />
              <path
                d="M54.8566 45.8L47.2764 50.332L47.5768 53.4422L54.8566 45.8Z"
                fill="#FF5C16"
              />
              <path
                d="M50.0032 61.7986L46.668 64.3392L50.0032 65.3328V61.7986Z"
                fill="#FF5C16"
              />
              <path
                d="M51.6808 56.27V56.2679L51.6798 56.2689L47.5766 53.4446L46.9355 57.5983H50.0042L51.6692 59.1773L51.6808 56.27Z"
                fill="#FF5C16"
              />
              <path
                d="M40.1265 65.3328L35.2754 66.7779L33.7998 61.7986H40.1265V65.3328Z"
                fill="#E34807"
              />
              <path
                d="M43.1947 57.5969L44.1213 63.6016L42.8371 60.263L38.46 59.177L40.125 57.5969H43.1936H43.1947Z"
                fill="#E34807"
              />
              <path
                d="M50.0039 65.3328L54.855 66.7779L56.3306 61.7986H50.0039V65.3328Z"
                fill="#E34807"
              />
              <path
                d="M46.9354 57.5969L46.0088 63.6016L47.293 60.263L51.6701 59.177L50.0041 57.5969H46.9354Z"
                fill="#E34807"
              />
              <path
                d="M33.7998 61.7965L35.2754 56.2678H38.4488L38.4605 59.1761L42.8377 60.2621L44.1218 63.6008L43.4618 64.3361L40.1265 61.7954H33.7998V61.7965Z"
                fill="#FF8D5D"
              />
              <path
                d="M56.3308 61.7965L54.8552 56.2678H51.6818L51.6701 59.1761L47.293 60.2621L46.0088 63.6008L46.6689 64.3361L50.0041 61.7954H56.3308V61.7965Z"
                fill="#FF8D5D"
              />
              <path
                d="M47.2736 50.3291H45.0639H42.8541L42.5537 53.4393L44.1203 63.5977H46.0074L47.5751 53.4393L47.2736 50.3291Z"
                fill="#FF8D5D"
              />
              <path
                d="M35.2754 45.8L33.7998 51.5933L35.2754 56.2677H38.4488L42.5542 53.4422L35.2754 45.8Z"
                fill="#661800"
              />
              <path
                d="M42.2789 58.8031H40.8413L40.0586 59.5702L42.8395 60.2599L42.2789 58.802V58.8031Z"
                fill="#661800"
              />
              <path
                d="M54.8549 45.8L56.3305 51.5933L54.8549 56.2677H51.6815L47.5762 53.4422L54.8549 45.8Z"
                fill="#661800"
              />
              <path
                d="M47.8547 58.8031H49.2943L50.0771 59.5713L47.293 60.262L47.8547 58.802V58.8031Z"
                fill="#661800"
              />
              <path
                d="M46.3404 65.5393L46.6683 64.3386L46.0082 63.6033H44.12L43.46 64.3386L43.7879 65.5393"
                fill="#661800"
              />
              <path
                d="M46.3405 65.5388V67.5216H43.7881V65.5388H46.3405Z"
                fill="#C0C4CD"
              />
              <path
                d="M40.1279 65.3307L43.7911 67.5207V65.5379L43.4632 64.3372L40.1279 65.3307Z"
                fill="#E7EBF6"
              />
              <path
                d="M50.005 65.3307L46.3418 67.5207V65.5379L46.6697 64.3372L50.005 65.3307Z"
                fill="#E7EBF6"
              />
            </g>
          </g>
          <g clipPath="url(#clip4_670_20)">
            <path d="M99 41H67V73H99V41Z" fill="#0052FF" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M71.75 57C71.75 63.2132 76.7868 68.25 83 68.25C89.2132 68.25 94.25 63.2132 94.25 57C94.25 50.7868 89.2132 45.75 83 45.75C76.7868 45.75 71.75 50.7868 71.75 57ZM80.125 53.375C79.7108 53.375 79.375 53.7108 79.375 54.125V59.875C79.375 60.2892 79.7108 60.625 80.125 60.625H85.875C86.2892 60.625 86.625 60.2892 86.625 59.875V54.125C86.625 53.7108 86.2892 53.375 85.875 53.375H80.125Z"
              fill="white"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_670_20"
          x1="64"
          y1="95.5"
          x2="64"
          y2="111"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_670_20">
          <rect width="128" height="128" fill="white" />
        </clipPath>
        <clipPath id="clip1_670_20">
          <rect x="29" y="79" width="32" height="32" rx="3" fill="white" />
        </clipPath>
        <clipPath id="clip2_670_20">
          <rect x="67" y="79" width="32" height="32" rx="3" fill="white" />
        </clipPath>
        <clipPath id="clip3_670_20">
          <rect x="29" y="41" width="32" height="32" rx="3.9" fill="white" />
        </clipPath>
        <clipPath id="clip4_670_20">
          <rect x="67" y="41" width="32" height="32" rx="3.9" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default MobileWithLogos;
